import Timesheet from "../models/Timesheet";
import Utils from "../utils/Utils";
import ApiService from "./ApiService";

export default class TimesheetReportService {
  public static async getFile(teammemberReport: any) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/reports/timesheetReportFile`, { teammemberReport }).then((result) => {
        resolve(result.data);
      });
    });
  }

  public static async send(teammemberReport: any, projectLeadEmail: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/reports/sendTimesheetReport/${projectLeadEmail}`, { teammemberReport }).then((result) => {
        resolve(result.data);
      });
    });
  }

  public static async getList(startDate: Date, endDate: Date, projectLeadId: any): Promise<Timesheet[]> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/reports/timesheetReport`, { startDate, endDate, projectLeadId })
        .then((result) => {
          if (!result.data) {
            resolve([]);
          } else {
            const retVal = result.data.map((doc: any) => {
              if (doc.Date) {
                doc.Date = Utils.vsDateToDatetime(doc.Date);
              }
              const item = { id: doc.id, ...doc } as Timesheet;
              return item;
            });
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject(commitmentError));
    });
  }
}
